@if (sortedLikedBy()?.length) {
  <div class="recommendations" [class.secondary]="variant() === 'secondary'" (click)="openFollowersModal()">
    <div class="member-avatars">
      @for (likedUser of sortedLikedBy().slice(0, 3); track likedUser) {
        <div
          class="item"
          [style]="{
            backgroundImage: 'url(' + likedUser?.avatar_url + ')',
          }"
        ></div>
      }
    </div>
    <div class="info">
      <span class="name">{{ sortedLikedBy()[0].username }}</span>
      @if (sortedLikedBy().length === 1) {
        recommends this
      }
      @if (sortedLikedBy().length > 1) {
        and other friends recommend this
      }
    </div>
  </div>
}
